import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    buttonGroupDefault: {
      '& .MuiButton-root': {
        backgroundColor: palette.navCompanyContextActions,

        '&:not(last-child)': {
          borderRightColor: 'rgba(256, 256, 256, .2)',
        },
      },

      '& .MuiButton-root + .MuiButton-root': {
        minWidth: 0,
        paddingLeft: 4,
        paddingRight: 4,
      },

      '& .MuiButton-label': {
        fontSize: 12,
        color: palette.white,
      },
    },
    defaultButtonStyle: {
      border: `1px solid ${palette.blue}`,
      boxShadow: 'unset',
      maxHeight: 27,
      margin: '0px 4px',
      '& .MuiButton-root': {
        backgroundColor: palette.white,

        '&:not(last-child)': {
          borderRightColor: 'rgba(0, 100, 175, .21)',
          backgroundColor: palette.white,
          boxShadow: 'unset',
        },
      },

      '& .MuiButton-root + .MuiButton-root': {
        minWidth: 0,
        paddingLeft: 4,
        paddingRight: 4,
        backgroundColor: palette.white,
        boxShadow: 'unset',
      },

      '& .MuiButton-label': {
        fontSize: 12,
        color: palette.blue,
      },
      '& .MuiButtonGroup-contained': { boxShadow: 'unset' },
    },
    buttonGroupAdmin: {
      '& .MuiButton-root': {
        backgroundColor: palette.navAdminActions,
      },
    },
    buttonGroupSuperAdmin: {
      '& .MuiButton-root': {
        backgroundColor: palette.navSuperAdminActions,
      },
    },
    buttonGroupCompanyContext: {
      '& .MuiButton-root': {
        backgroundColor: palette.navCompanyContextActions,
      },
    },
    buttonGroupOperator: {
      '& .MuiButton-root': {
        backgroundColor: palette.navOperatorActions,
      },
    },

    menuItem: {
      fontSize: 12,
      fontWeight: typography.fontWeightMedium,
      justifyContent: 'space-between',
      alignItems: 'center',

      '&:hover': {
        backgroundColor: 'rgba(239, 205, 51, .15)',
      },
    },
    menuItemWithIcon: {
      paddingRight: 0,
    },
  });
